import { render, staticRenderFns } from "./realNameForm.vue?vue&type=template&id=1bf36e32&scoped=true&"
import script from "./realNameForm.vue?vue&type=script&lang=js&"
export * from "./realNameForm.vue?vue&type=script&lang=js&"
import style0 from "./realNameForm.vue?vue&type=style&index=0&id=1bf36e32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf36e32",
  null
  
)

export default component.exports